import { useCallback } from 'react'
import { useIntl, type PrimitiveType } from 'react-intl'

type PrimitiveValues = Record<string, PrimitiveType>

export function useFormatMessage() {
	const intl = useIntl()
	/** Safe only for primitive interpolation values. For React element values use intl.formatMessage directly. */
	const t = useCallback(
		(id: string, values?: PrimitiveValues): string => intl.formatMessage({ id }, values),
		[intl],
	)
	return { t }
}
